import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { REDUCER_NAME } from './slice';

const getRoot = prop([REDUCER_NAME]);

export const getErrorsByPageName = createSelector(
	getRoot,
	(state, pageName) => pageName,
	(state, pageName) => propOr(EMPTY_VALUES.ARRAY, pageName)(state),
);
